import { Facets } from "./components/facets/facets";
import { ResultsView } from "./components/resultsView/resultsView";
import { Base } from "./productResults.base";

export const ProductResults = Object.assign(Base, {
    Facets: Facets,
    ResultsView: ResultsView
});
